import {
  getValueByTitle,
  notificationMessage,
} from "common/components/NotificationsMenu/components/constants"
import { useNotificationsContext } from "common/context/NotificationsProvider"
import { useTranslation } from "react-i18next"
import "../style.scss"
import NotificationsItemIcon from "./NotificationsItemIcon"

const NotificationsItem = ({ notification }: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  // @ts-expect-error TS(2339): Property 'handleOpenNotification' does not exist o...
  const { handleOpenNotification, hideNotifications } =
    useNotificationsContext()

  const onNotificationClick = () => {
    const selectedNotification = {
      id: notification.id,
      type: notification.type,
      read: notification.read,
      messageId: getValueByTitle(notification, "Id"),
      empresaId: getValueByTitle(notification, "EmpresaId"),
    }
    handleOpenNotification(selectedNotification)
    hideNotifications()
  }

  return (
    <div
      className={`notifications-item  ${
        notification.read ? "" : "notifications-item-no-read"
      } w-100 d-flex flex-row`}
      onClick={onNotificationClick}
    >
      <NotificationsItemIcon notification={notification} />
      <div className='text-left notifications-menu-item-info-container d-flex flex-column justify-content-center '>
        {notificationMessage(notification, t)}
      </div>
    </div>
  )
}

export default NotificationsItem
